import { render, staticRenderFns } from "./DirectSalesRep.vue?vue&type=template&id=62396876&scoped=true&"
import script from "./DirectSalesRep.vue?vue&type=script&lang=js&"
export * from "./DirectSalesRep.vue?vue&type=script&lang=js&"
import style0 from "./DirectSalesRep.vue?vue&type=style&index=0&id=62396876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62396876",
  null
  
)

export default component.exports